enum ImmovablePatrimonyTypeEnum {
    URBAN_COMPLEX = 'URBAN_COMPLEX', //Conjunto Urbano
    ARCHITECTURAL_STRUCTURE = 'ARCHITECTURAL_STRUCTURE', //Estrutura Arquitetônica
    ENGINEERING_WORKS = 'ENGINEERING_WORKS', //Obras de Engenharia
}

export default ImmovablePatrimonyTypeEnum;
